module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browser_title":"My Playlists"},"ja":{"browser_title":"再生リスト"}}')
  delete Component.options._Ctor
}
